var App = App || {};

App.Plugins = (function ($) {

    'use strict';

    const numeratorMobile = 1.5;
    const numeratorDesktop = 2.5;
    const denominatorMobile = 48;
    const denominatorDesktop = 24;

    $(window).on("load orientationchange resize scroll", function () {
        ParallaxImage();
    });

    function Juxtapose() {
        window.juxtapose.sliders.forEach(function (slider) {
            slider.wrapper.style.width = "100%";
            slider.setWrapperDimensions();
        });
    }

    function JuxtaposeInit() {
        $(window).on("load resize orientationchange", Juxtapose);
    };

    function ParallaxBackground() {
        $(".has-image.has-parallax-bg").each(function (e) {
            var $this = $(this),
                $image = $this.find(".image");

            $image.each(function () {
                var $this = $(this);

                if (ZagBreakpoints.GetBreakpoint() === "xs" || ZagBreakpoints.GetBreakpoint() === "sm") {
                    $this.ZagParallax({
                        divisor: numeratorMobile
                    });
                }
                else {
                    $this.ZagParallax({
                        divisor: numeratorDesktop
                    });
                }
            });
        });
    }

    function ParallaxImage() {
        $(".has-image.has-parallax-image").each(function (e) {
            var $this = $(this),
                $image = $this.find(".parallax-image > img"),

                scroll = $(document).scrollTop(),
                offset = $this.offset().top,
                parallax;

            if (ZagBreakpoints.GetBreakpoint() === "xs" || ZagBreakpoints.GetBreakpoint() === "sm") {
                parallax = Math.floor((scroll - offset) * numeratorMobile / denominatorMobile);
            }
            else {
                parallax = Math.floor((scroll - offset) * numeratorDesktop / denominatorDesktop);
            }

            $image.each(function (e) {
                var $this = $(this);

                $this.css("transform", "scale(1.3) translateY(" + parallax + "px)");
            });
        });
    }

    return {
        Juxtapose: Juxtapose,
        JuxtaposeInit: JuxtaposeInit,
        ParallaxBackground: ParallaxBackground,
        ParallaxImage: ParallaxImage
    };

})(jQuery);

$(function () {
    App.Plugins.JuxtaposeInit();
    App.Plugins.ParallaxBackground();
    App.Plugins.ParallaxImage();
});